module.exports = __webpack_public_path__ + "img/generic_haunt_button.a9c75cb2.png";